import { Helpers } from "@HELPERS/helpers";
// @ts-ignore
import { Datepicker } from 'vanillajs-datepicker';
import MicroModal from 'micromodal';
import * as AOS from "aos";

export namespace Global {
	let setupAllDropdownMenus = () => {
		let dropdownElementList = document.querySelectorAll('.js-dropdown');

		//DONT RUN THIS FUNCTION IF WE DONT HAVE DROPDOWNELEMENTS
		if(!dropdownElementList.length) {
			return;
		}

		dropdownElementList.forEach((dropdownLink) => {
			let parentEl = dropdownLink.closest('.dropdown');
			if(dropdownLink.getAttribute('data-direction') === 'right') {
				parentEl.classList.add('dropdown--right');
			}
			let list = parentEl.querySelector('.dropdown-menu');
			dropdownLink.addEventListener('click', (e) => {
				e.preventDefault();
				if (dropdownLink.classList.contains('show')) {
					dropdownLink.classList.remove('show');
					dropdownLink.setAttribute('aria-expanded', 'false');
					if (list) {
						list.classList.remove('show');
					}
				} else {
					dropdownLink.classList.add('show');
					dropdownLink.setAttribute('aria-expanded', 'true');
					if (list) {
						list.classList.add('show');
					}
				}
			});

			Helpers.CloseOnOutsideClick(parentEl, () => {
				dropdownLink.classList.remove('show');
				dropdownLink.setAttribute('aria-expanded', 'false');
				if (list) {
					list.classList.remove('show');
				}
			});
		});
	};

	let setupVideoModal = () => {
		let videoPlayers = document.querySelectorAll('.js-video');
		let videoModal = document.querySelector('.js-video-modal');

		//DONT RUN THIS FUNCTION IF WE DONT HAVE VIDEOS
		if(!videoPlayers.length) {
			return;
		}

		let closeVideoModal = (id, frame) => {
			frame.setAttribute('src', '');
			Helpers.ToggleScroll();
		}

		videoPlayers.forEach((video) => {
			let modalID = video.getAttribute('data-modalID');
			let vimeoID = video.getAttribute('data-vimeoID');
			video.addEventListener('click', (e) => {
				if(videoModal) {
					videoModal.setAttribute('id', modalID);
					let frame = videoModal.querySelector('iframe');
					frame.setAttribute('src', `https://player.vimeo.com/video/${vimeoID}?h=9d5f27ade1&&color=E7E7E7&title=0&byline=0&portrait=0`);
					frame.setAttribute('class', modalID);

					MicroModal.show(`${modalID}`, {
						onShow: modal => Helpers.ToggleScroll(),
						onClose: modal => closeVideoModal(modalID, frame)
					});
				}
				e.preventDefault();
			});
		});
	}

	let setupDatepickerElements = () => {
		let datepickerElements = document.querySelectorAll('.js-datepicker');

		//DONT RUN THIS FUNCTION IF WE DONT HAVE DATEPICKERS
		if(!datepickerElements.length) {
			return;
		}

		datepickerElements.forEach((elem) => {
			let parentEl = elem.parentElement;
			let datepicker = new Datepicker(elem);
			let datepickerIcon =  parentEl.querySelector('.js-datepicker-icon');
			datepickerIcon.addEventListener('click', () => {
				datepicker.show();
			});
		});
	};

	let calculateScrollbarWidth = () => {
		let elem = document.createElement('div');
		elem.style.cssText = 'width:100%;';
		document.body.appendChild(elem);
		let constrainedWidth = elem.offsetWidth;

		elem.style.cssText = 'width: 100vw';
		let fullWidth = elem.offsetWidth;
		let scrollbarWidth = Math.ceil(fullWidth - constrainedWidth);

		document.documentElement.style.setProperty(
			'--scrollbar-width',
			scrollbarWidth + 'px',
		);

		elem.parentNode.removeChild(elem);
	};

	let mobileNavSetup = () => {
		let trigger = document.querySelector('.js-mobile-nav-trigger');
		let menuWrap = document.querySelector('.js-menu-wrap');
		let bd = document.body;
		let menuIcon = document.getElementById('js-menuIcon');

		if (trigger) {
			trigger.addEventListener('click', () => {
				if (menuWrap.classList.contains('state-visible')) {
					menuWrap.classList.remove('state-visible');
					trigger.classList.remove('state-visible');
					bd.classList.remove('state-fixed');
					menuIcon.classList.toggle('icon-menu');
					menuIcon.classList.toggle('icon-x');
				} else {
					menuWrap.classList.add('state-visible');
					trigger.classList.remove('state-visible');
					bd.classList.add('state-fixed');
					menuIcon.classList.toggle('icon-menu');
					menuIcon.classList.toggle('icon-x');
				}
			});
		}
	};

	/**
	 * Container Initialization
	 */
	export const init = () => {
		calculateScrollbarWidth();
		setupAllDropdownMenus();
		mobileNavSetup();
		setupDatepickerElements();
		setupVideoModal();
		AOS.init({
			startEvent: 'load',
			once: true
		});
	};
}

document.addEventListener("DOMContentLoaded", () => {
    Global.init();
});